export default "__VITE_ASSET__CkW78xCy__"